"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedError = void 0;
class UnsupportedError extends Error {
    name = 'UnsupportedError';
    code = 500;
    constructor(...args) {
        super(...args);
        Error.captureStackTrace(this, UnsupportedError);
    }
}
exports.UnsupportedError = UnsupportedError;
//# sourceMappingURL=unsupported-error.js.map